<template>
<div>
    <b-modal id="createLedesFormModal" centered size="xl" no-close-on-backdrop ref="createLedesFormModal" :title="$t('createLedes.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-col class="col-lg-12">
                <label for="create-ledes-ledes-input">{{ $t('createLedes.ledes') }}</label>
                <validation-provider #default="{ errors }" :name=" $t('createLedes.ledes')" rules="required">
                    <b-form-textarea id="create-ledes-ledes-input" class="no-wrap-textarea" size="sm" rows="20" :state="errors.length > 0 ? false:null" v-model="fileContains" />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-col>
        </validation-observer>
    </b-modal>
</div>
</template>

  
<script>
export default {
    props: {
        getInvoiceList: {
            type: Function
        }
    },
    data() {
        return {
            invoiceId: 0,
            clientAccountingId: 0,
            clientAccountingLedesId: 0,
            base64: '',
            encodedLedes: '',
            employeeId: null,
            fileContains: '',
            fileName: '',
            type: '',
            ledesTypeId: 0
        }
    },
    methods: {
        showInfo(invoiceId, clientAccountingId, ledesTypeId) {
            this.invoiceId = invoiceId
            this.clientAccountingId = clientAccountingId
            this.ledesTypeId = ledesTypeId
            this.$refs['createLedesFormModal'].show()
            const data = {
                invoiceId: this.invoiceId,
                employeeId: localStorage.getItem('EmployeeId')
            }
            const controller = {
                name: 'Invoice',
                actionName: 'CreateInvoiceCsvFile'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.fileName = response.data.fileName
                    this.type = response.data.fileExtension
                    this.fileContains = response.data.fileContains
                } else {
                    this.$bvModal.hide('createLedesFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        downloadLedes() {
            let data = {
                id: this.clientAccountingLedesId
            }
            let controller = {
                name: 'ClientAccountingLedes',
                actionName: 'DownloadClientAccountingLedesFile'
            }
            let payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    const parts = response.data.fileName.split('.');
                    const name = parts[0];
                    const type = parts[1];
                    this.$downloadFile(name, response.data.fileAsBase64, type)

                    if (this.ledesTypeId == 7) {
                        data = {
                            InvoiceId: this.invoiceId,
                        }
                        controller = {
                            name: 'Invoice',
                            actionName: 'CreateInvoiceXmlFileForLedes'
                        }
                        payload = {
                            data: data,
                            controller: controller
                        }

                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$downloadFile(name, response.data.base64File, ".xml")
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                            }

                        })

                        data = {
                            InvoiceId: this.invoiceId,
                        }
                        controller = {
                            name: 'Invoice',
                            actionName: 'CreateInvoiceExcelFileForLedes'
                        }
                        payload = {
                            data: data,
                            controller: controller
                        }

                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$downloadFile(name, response.data.fileAsBase64, ".xlsx")
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                            }
                        })
                    }
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    try {
                        this.encodedLedes = btoa(unescape(encodeURIComponent(this.fileContains)));
                    } catch (e) {
                        console.error('Base64 encode hatası:', e);
                    }
                    const data = {
                        base64: this.encodedLedes,
                        invoiceId: this.invoiceId,
                        clientAccountingId: this.clientAccountingId,
                        employeeId: localStorage.getItem('EmployeeId'),
                        name: this.fileName,
                        type: this.type
                    }
                    const controller = {
                        name: 'ClientAccountingLedes',
                        actionName: 'SaveClientAccountingLedes'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('createLedesFormModal')
                            this.clientAccountingLedesId = response.data.clientAccountingLedesId
                            this.downloadLedes()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>
  
<style scoped>
.tab-content>.active {
    display: block;
    width: 75em;
}
.no-wrap-textarea {
    white-space: nowrap!important;
    overflow-x: auto!important;
    overflow-y: hidden!important;
    resize: none!important;
  }
</style>
